import script from "./PoliticaComissao.vue?vue&type=script&setup=true&lang=js"
export * from "./PoliticaComissao.vue?vue&type=script&setup=true&lang=js"

import "./PoliticaComissao.vue?vue&type=style&index=0&id=dff226a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dff226a6"]])

export default __exports__